<template>
  <div>
    <vs-popup
      type="filled"
      title="Ürün Resim"
      :active.sync="isSidebarActiveLocal"
      style="text-align: center"
      @cancel="clearFields"
      @close="clearFields"
    >
      <div v-if="selectedValue">
        <div v-if="selectedValue.imagesList">
          <img
            v-if="selectedValue.imagesList.length == 0"
            :src="imgSrc"
            style="max-width: 70%"
          />
          <div v-else>
            <b-row>
              <b-col cols="2">
                <b-row
                  class="mt-2"
                  lg="3"
                  cols="3"
                  v-for="(row, rowIndex) in selectedValue.imagesList"
                  :key="rowIndex"
                >
                  <b-form-group label-for="renk">
                    <img
                      :src="row.imageUrl"
                      style="width: 80px"
                      class="grid-view-img px-4"
                      @click="resimDegistir(row.imageUrl)"
                    />
                  </b-form-group>
                </b-row>
              </b-col>
              <b-col>
                <div v-if="genelresim == ''">
                  <img
                    :src="selectedValue.imagesList[0].imageUrl"
                    style="max-width: 70%"
                    class="grid-view-img px-4"
                  />
                </div>
                <div v-else>
                  <img :src="genelresim" style="max-width: 70%" />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>

      <!-- Display additional values with null checks -->
      <h4 style="color: black">{{ stockCode || "" }}</h4>

      <p style="color: black; margin: 0px" v-if="stockName">{{ stockName }}</p>

      <b-row>
        <b-col>
          <div class="flex items-center">
            <label for="itemQuantity" style="color: black; font-weight: bold"
              >Adet:</label
            >
            <vs-input
              v-model="item.quantity"
              id="itemQuantity"
              type="number"
              min="0"
              class="small-input"
              style="color: black; font-weight: bold"
            />
          </div>
        </b-col>

        <b-col>
          <b-button
            class="bg-danger"
            style="border-color: white; margin-top: 6px"
            size="sm"
            @click="addItemstoCard"
          >
            {{ $t("getQuote") }}
            <Icon icon="iconamoon:shopping-card-add" width="20" height="20" />
          </b-button>
        </b-col>
      </b-row>
    </vs-popup>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";

export default {
  props: ["popupResimSw", "imgSrc", "stockCode", "stockName", "selectedValue"],
  components: { Icon },

  data() {
    return {
      genelresim: "",
      item: {
        quantity: 1, // Set default quantity
        stockPrice: 0, // Set default stock price
        // Include other item properties as needed
      },
      popupResim: false,
    };
  },
  watch: {
    popupResimSw(val) {
      return val;
    },
  },
  computed: {
    isInCart() {
      return (itemId) => this.$store.getters["eCommerce/isInCart"](itemId);
    },
    isSidebarActiveLocal: {
      get() {
        return this.popupResimSw;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },
  },
  methods: {
    clearFields() {
      this.genelresim = "";
    },
    resimDegistir(val) {
      this.genelresim = val;
    },
    addItemstoCard() {
      const quantity = parseInt(this.item.quantity);
      let itemVal = {
        stockCode: this.stockCode,
        imageUrl: this.imgSrc,
        stockName: this.stockName,
        priceLine: this.selectedValue.stockPrice,
        priceLineUSD: this.selectedValue.stockCurrencyUsdPrice,
        priceLineEUR: this.selectedValue.stockCurrencyEurPrice,
        stockCurrencyEur: this.selectedValue.stockCurrencyEur,
        stockCurrencyUsd: this.selectedValue.stockCurrencyUsd,
        stockWidth: this.selectedValue.attr2_en,
        stockLength: this.selectedValue.attr3_boy,
        stockWeight: this.selectedValue.attr10_agirlik,
        quantityLine: quantity, // Corrected from this.quantity to quantity
        stockQuantity: this.selectedValue.stockCount,
      };
      this.isInCart(this.stockCode)
        ? this.$store.dispatch("eCommerce/toggleItemInCart", itemVal)
        : "";
      this.additemInCart(itemVal);
      // Close the popup after adding the item
      this.isSidebarActiveLocal = false;
    },
    additemInCart(item) {
      // Adjust this logic according to your store structure and actions
      item["quantity"] = this.item.quantity;
      this.$store.dispatch("eCommerce/additemInCart", item);
    },
    onResimGoster() {
      this.$emit("closeSidebar"); // Close any other sidebar if needed
      this.$emit("update:popupResimSw", true);
    },
  },
};
</script>
